import { Flex, Text, Tooltip } from '@chakra-ui/react';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonIcon } from '@morressier/alembic';
import { DividerVertical } from '../Submission/OverviewTab';

interface ContactJournalHeaderProps {
  setIsContactModalOpen: (arg0: boolean) => void;
}
const ContactJournalHeader = ({
  setIsContactModalOpen
}: ContactJournalHeaderProps) => {
  return (
    <Flex
      justifyContent={'flex-end'}
      alignItems={'center'}
      gap={2}
      fontWeight="semibold"
    >
      <DividerVertical />
      <Text textStyle={'headingItem'}>Contact Journal</Text>
      <Tooltip
        hasArrow
        shouldWrapChildren
        placement="top-start"
        label={'Contact Journal'}
        data-cy="info-tooltip"
      >
        <ButtonIcon
          size="regular"
          ariaLabel="Send Mail"
          variant="primary"
          onClick={() => {
            setIsContactModalOpen(true);
          }}
          icon={<FontAwesomeIcon icon={faEnvelope} size="lg" />}
        />
      </Tooltip>
    </Flex>
  );
};

export default ContactJournalHeader;
